import { useState } from "react";

// Cards or a list, for a department page and search results (KALI-33). Every page opens as
// cards until this visitor picks the list; their choice is kept in this browser only.
export type ListingView = "cards" | "list";

const KEY = "kalikaya.listingView";

function read(): ListingView {
  try {
    return localStorage.getItem(KEY) === "list" ? "list" : "cards";
  } catch {
    return "cards";
  }
}

export function useListingView(): [ListingView, (view: ListingView) => void] {
  const [view, setView] = useState(read);
  return [
    view,
    (next) => {
      setView(next);
      try {
        localStorage.setItem(KEY, next);
      } catch {
        // Not remembered this time; the page still switches.
      }
    },
  ];
}
